export function snack(mesasge, duration = 3000) {
    const snack = document.createElement('snack')
    snack.id = 'snackbar'
    snack.innerHTML = mesasge
    document.body.appendChild(snack)

    setTimeout(() => {
        snack.remove()
    }, duration)
}